import { BFLType } from "../../../types/DBTables";
import { useForm } from "react-hook-form";

import ValidationSummaryMessages from "../../Configuration/ValidationSummaryMessages";
import { IModuleRound } from "../../../modules/roundHandler";
import BFLEditor from "./BFLEditor";

import { useBflHandler } from "../../../modules/Beräkningsmoduler/bflHandler";
import { useGlobalData } from "../../GlobalDataProvider";
import { Card } from "react-bootstrap";
import { logDebugSilently } from "../../../modules/logger";
import { Colors } from "../../../modules/Colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  module: IModuleRound;
  title?: string;
  bfName: BFLType;
  onCancel: () => void;
  onSubmit: (data: any) => void;
}

const ModuleBFLForm = ({ module, onCancel, onSubmit, bfName, title }: IProps) => {
  const bflHandler = useBflHandler();
  const globalData = useGlobalData();

  logDebugSilently("Render ModuleBFLForm:" + bfName + "@" + new Date());

  const bflForm = module.bfs ? module.bfs[bfName] : undefined; //Contains the saved state of this BFL if any, otherwise undefined. If it exists, we use åtgärdat & new values entered during the BFL visit.

  let data = bflHandler.prepareData(module, bfName, bflForm);
  if (data) {
    data = { ...data }; //Make a shallow copy
  }

  //Split the data into two arrays, one with values and one without. This is to make it possible to bind the items to different tables in the form.
  //This is an ugly hack, but it works. It would be nicer to split the funktionsKontroller into two different entity sets, but then we would have to change all BFLs (And more logic in the report etc...)
  (data as any).funktionsKontrollerWValues = data.funktionsKontroller.filter((fk) => fk.kWhs || fk.energiSlag);
  (data as any).funktionsKontrollerWOValues = data.funktionsKontroller.filter((fk) => !fk.kWhs && !fk.energiSlag);
  delete (data as any).funktionsKontroller; //Remove the original array. It will be reconstituted when the form is submitted (onReady)

  const formHook = useForm({
    defaultValues: data as any,
  }); //{register,  handleSubmit,  formState: { errors }}
  const {
    handleSubmit,
    formState: { errors },
  } = formHook;

  //todo: kan denna faila om man har 2 moduler av samma typ. Får man in data från den andra modulen?
  const frmBfName = formHook.getValues("bfName");

  if (frmBfName !== bfName) {
    //React verkar hålla i formuläret och det initieras inte automatiskt om när man byter BFL.
    logDebugSilently("Render ModuleBFLForm reset! :" + bfName + "," + frmBfName + " @" + new Date());
    formHook.reset(data);
  }

  const onHelp = () => {
    PubSub.publish("ShowHelp", "help_" + bfName.replaceAll("_", "")); //);
  };

  const onReady = (data: any) => {
    //Clean what is going to be saved to the server...

    //Reconstitute the original array
    data.funktionsKontroller = (data.funktionsKontrollerWValues || []).concat(data.funktionsKontrollerWOValues || []);
    delete data.funktionsKontrollerWValues;
    delete data.funktionsKontrollerWOValues;

    const toSubmit = { ...data };
    if (!globalData.isDebug) delete toSubmit.debug;
    if (!toSubmit.error) delete toSubmit.error;

    onSubmit(toSubmit);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onReady)}>
        <Card>
          {/* <Card.Body className="pt-0 pb-1"></Card.Body> */}
          <BFLEditor formHook={formHook as any} module={module} bfName={bfName} />
          <ValidationSummaryMessages errors={errors} />
          <div className="flex-grow-1"></div>
          <Card.Footer>
            <div className="module">
              <button type="button" className="btn btn-info" onClick={onHelp}>
                Hjälp
              </button>
            </div>
            {!globalData.isOnline && (
              <>
                <>
                  <div
                    className="card-footer-info p-2 m-2  "
                    role="button"
                    style={{ backgroundColor: Colors.YellowMedium, color: Colors.GrayBlack, height: "100%", borderRadius: "5px" }}
                    onClick={() => PubSub.publish("ShowOfflineMessage", {})}
                  >
                    <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
                    <span className="d-none d-xl-block"> Du är offline - Ronderingen kan fortsättas men behöver sparas vid något senare tillfälle !</span>
                    <span className="d-none d-md-block d-xl-none"> Du är offline !</span>
                    <span className="d-block d-sm-block d-md-none"> Offline!</span>
                  </div>
                </>
              </>
            )}

            <div className="footerGroup">
              <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
                Bakåt
              </button>
              <button type="submit" className={"btn ms-2" + (globalData.isOnline ? " btn-success" : " btn-warning")}>
                Klar
              </button>
            </div>
          </Card.Footer>
        </Card>
      </form>
    </>
  );
};

export default ModuleBFLForm;
